import { TankBM } from '../../types/BusinessModel/Vessel/TankBM';
import { Tank } from '../../types/ViewModel/Vessel/Tank';
import { AdjacentTankFactory } from './AdjacentTankFactory';

export class TankFactory {
    constructor() {}
    public getTank(tank: TankBM): Tank {
        const adjacentTankFactory = new AdjacentTankFactory();

        return new Tank(
            tank.tankId,
            tank.tankName,
            tank.odfjellTankName,
            tank.volumeAt98Percent,
            tank.heatingMedium,
            tank.cargoPumpCapacity,
            tank.maxHeating,
            tank.heatingCapacity,
            tank.maxVapourPressure,
            tank.volume,
            tank.imoTankType,
            tank.ibcTankType,
            tank.hasPoCapacity,
            tank.maxWeightAt98Percent,
            tank.tankType,
            tank.position.startFrame,
            tank.position.endFrame,
            tank.position.xStart,
            tank.position.yStart,
            tank.position.height,
            tank.position.width,
            tank.position.section,
            tank.position.side,
            tank.hasCofferdamForward,
            tank.hasCofferdamStarboard,
            tank.hasCofferdamAft,
            tank.hasCofferdamPort,
            tank.allow2K,
            tank.coatingType,
            tank.coatingId,
            tank.hasCooling,
            tank.hasLitreWeightLimitation,
            tank.heatingType,
            tank.ibcCompatibilities.filter((o) => o != ''),
            tank.adjacentTanks.map((adjacentTank) => adjacentTankFactory.getAdjacentTank(adjacentTank)),
            tank.litreWeightHardRule,
            tank.litreWeightSoftRule,
            tank.fuelTankType,
            tank.widthInManifoldPlan,
            tank.orderInManifoldPlan
        );
    }

    public getCargoTankList(tankList: TankBM[]): Tank[] {
        if (tankList) {
            return tankList.map((tk) => this.getTank(tk)).filter((o) => o.tankType === 1) ?? [];
        }
        return [];
    }

    public getNonCargoTankList(tankList: TankBM[]): Tank[] {
        if (tankList) {
            return tankList.map((tk) => this.getTank(tk)).filter((o) => o.tankType !== 1) ?? [];
        }
        return [];
    }
}
